import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BypassSecurityPipe } from '../../pipes/bypass-security.pipe';

@Component({
  selector: 'app-event-intro-article',
  standalone: true,
  imports: [CommonModule, BypassSecurityPipe],
  templateUrl: './event-intro-article.component.html',
  styleUrls: ['./event-intro-article.component.less']
})
export class EventIntroArticleComponent {
  @Input() data: any;
}
